import { Action } from 'redux';
import { SubmissionRequestModel, GetColumnConfigPayload } from './../../models/SubmissionModel';

export enum SubmissionDataActionTypes {
    SUBMISSION_RESET = 'SUBMISSION_RESET',
    SUBMISSION_REQUEST = 'SUBMISSION_REQUEST',
    SUBMISSION_SUCCESS = 'SUBMISSION_REQUEST_SUCCESS',
    SUBMISSION_FAILURE = 'SUBMISSION_REQUEST_FAILURE',
    DELETE_SUBMISSION = 'DELETE_SUBMISSION',
    DELETE_SUBMISSION_SUCCESS = 'DELETE_SUBMISSION_SUCCESS',
    DELETE_SUBMISSION_FAILURE = 'DELETE_SUBMISSION_FAILURE',
    SHOW_VIEW_FORM_DIALOG = 'SHOW_VIEW_FORM_DIALOG',
    CLOSE_VIEW_FORM_DIALOG = 'CLOSE_VIEW_FORM_DIALOG',
    SHOW_EDIT_FORM_DIALOG = 'SHOW_EDIT_FORM_DIALOG',
    CLOSE_EDIT_FORM_DIALOG = 'CLOSE_EDIT_FORM_DIALOG',
    SHOW_DELETE_RECORD_DIALOG = 'SHOW_DELETE_RECORD_DIALOG',
    CLOSE_DELETE_RECORD_DIALOG = 'CLOSE_DELETE_RECORD_DIALOG',
    GET_COLUMN_CONFIG = 'GET_COLUMN_CONFIG',
    GET_COLUMN_SUCCESS = 'GET_COLUMN_SUCCESS',
    GET_COLUMN_FAILURE = 'GET_COLUMN_FAILURE'
}

export interface SubmissionReset extends Action {
    type: SubmissionDataActionTypes.SUBMISSION_RESET
}

export const submissionReset = (): SubmissionReset => ({
    type: SubmissionDataActionTypes.SUBMISSION_RESET,
});

export interface SubmissionRequest extends Action {
    type: SubmissionDataActionTypes.SUBMISSION_REQUEST,
    data: SubmissionRequestModel;
}

export const submissionRequest = (data: SubmissionRequestModel): SubmissionRequest => ({
    type: SubmissionDataActionTypes.SUBMISSION_REQUEST,
    data
});

export interface SubmissionSuccess extends Action {
    type: SubmissionDataActionTypes.SUBMISSION_SUCCESS,
    data: any
}

export const submissionSuccess = (data: any) : SubmissionSuccess => ({
    type: SubmissionDataActionTypes.SUBMISSION_SUCCESS,
    data
});

export interface SubmissionFailure extends Action {
    type: SubmissionDataActionTypes.SUBMISSION_FAILURE
}

export const submissionFailure = () : SubmissionFailure => ({
    type: SubmissionDataActionTypes.SUBMISSION_FAILURE
});

export interface DeleteSubmission extends Action {
    type: SubmissionDataActionTypes.DELETE_SUBMISSION,
    data: any
}

export const deleteSubmission = (data: any) : DeleteSubmission => ({
    type: SubmissionDataActionTypes.DELETE_SUBMISSION,
    data
});

export interface DeleteSubmissionSuccess extends Action {
    type: SubmissionDataActionTypes.DELETE_SUBMISSION_SUCCESS
}

export const deleteSubmissionSuccess = () : DeleteSubmissionSuccess => ({
    type: SubmissionDataActionTypes.DELETE_SUBMISSION_SUCCESS
});

export interface DeleteSubmissionFailure extends Action {
    type: SubmissionDataActionTypes.DELETE_SUBMISSION_FAILURE
}

export const deleteSubmissionFailure = () : DeleteSubmissionFailure => ({
    type: SubmissionDataActionTypes.DELETE_SUBMISSION_FAILURE
});

export interface ShowViewFormDialog extends Action {
    type: SubmissionDataActionTypes.SHOW_VIEW_FORM_DIALOG
}

export const showViewFormDialog = () : ShowViewFormDialog => ({
    type: SubmissionDataActionTypes.SHOW_VIEW_FORM_DIALOG
});

export interface ShowEditFormDialog extends Action {
    type: SubmissionDataActionTypes.SHOW_EDIT_FORM_DIALOG
}

export const showEditFormDialog = () : ShowEditFormDialog => ({
    type: SubmissionDataActionTypes.SHOW_EDIT_FORM_DIALOG
});

export interface ShowDeleteRecordDialog extends Action {
    type: SubmissionDataActionTypes.SHOW_DELETE_RECORD_DIALOG
}

export const showDeleteRecordDialog = () : ShowDeleteRecordDialog => ({
    type: SubmissionDataActionTypes.SHOW_DELETE_RECORD_DIALOG
});

export interface CloseViewFormDialog extends Action {
    type: SubmissionDataActionTypes.CLOSE_VIEW_FORM_DIALOG
}

export const closeViewFormDialog = () : CloseViewFormDialog => ({
    type: SubmissionDataActionTypes.CLOSE_VIEW_FORM_DIALOG
});

export interface CloseEditFormDialog extends Action {
    type: SubmissionDataActionTypes.CLOSE_EDIT_FORM_DIALOG
}

export const closeEditFormDialog = () : CloseEditFormDialog => ({
    type: SubmissionDataActionTypes.CLOSE_EDIT_FORM_DIALOG
});

export interface CloseDeleteRecordDialog extends Action {
    type: SubmissionDataActionTypes.CLOSE_DELETE_RECORD_DIALOG
}

export const closeDeleteRecordDialog = () : CloseDeleteRecordDialog => ({
    type: SubmissionDataActionTypes.CLOSE_DELETE_RECORD_DIALOG
});

export interface GetColumnConfig extends Action {
    type: SubmissionDataActionTypes.GET_COLUMN_CONFIG,
    data: GetColumnConfigPayload;
}

export const getColumnConfig = (data: GetColumnConfigPayload): GetColumnConfig => ({
    type: SubmissionDataActionTypes.GET_COLUMN_CONFIG,
    data
})

export interface GetColumnConfigSuccess extends Action {
    type: SubmissionDataActionTypes.GET_COLUMN_SUCCESS,
    data:any
}

export const getColumnConfigSuccess = (data: any): GetColumnConfigSuccess => ({
    type: SubmissionDataActionTypes.GET_COLUMN_SUCCESS,
    data
});

export interface GetColumnConfigFailure extends Action {
    type: SubmissionDataActionTypes.GET_COLUMN_FAILURE
}

export const getColumnConfigFailure = (): GetColumnConfigFailure => ({
    type: SubmissionDataActionTypes.GET_COLUMN_FAILURE
});
export type SubmissionDataActions = SubmissionReset | SubmissionRequest | SubmissionSuccess | SubmissionFailure
    | DeleteSubmission | DeleteSubmissionSuccess | DeleteSubmissionFailure | ShowEditFormDialog | CloseEditFormDialog
    | ShowViewFormDialog | CloseViewFormDialog | ShowDeleteRecordDialog | CloseDeleteRecordDialog
    | GetColumnConfigSuccess | GetColumnConfigFailure | GetColumnConfig;